import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, formattedPrice } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
import { setCustomerID } from "../../actions";
import CariTransactionsTable from "../../components/Tables/CariTransactionsTable";
import ReceivableServiceLink, { ReceivableServiceCell } from "../../components/ReceivableServiceLink";
import Swal from "sweetalert2";
import MainHelper from "../../helpers/MainHelper";
import ExcelJS from 'exceljs';
class CustomerDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: [],
      summery: [],
      calculates: [],
      cariByCompany: [],
      cariTransactions: [],
      showCariTransactions: false,
      isLoad: true,
      loading: false,
      filterLoading: false,
      deleteFromParasutLoading: false,
      formData: {
        id: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        tax_district: '',
        tax_no: '',
        title: '',
        city_id: '',
        district_id: '',
        is_supplier: '',
        p_id: '',
        save_parasut: false,
        urn: '',
        invoice_type: 'EARSIV'
      },
      cariByCompanyFilter: {
        time: '',
        start_time: '',
        end_time: '',
      },
      totalPaid: '',
      totalReceived: '',
      totalDebt: '',
      totalCredit: '',
      balance: '',
      cities: [],
      districts: []
    }
  }
  componentDidMount() {
    this.getCustomerInfo();
    this.getCariTransactonsSummery();
    this.getCities();
  }
  getCustomerInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/customer/info/' + id, 'get', null);
      this.props.setCustomerID(response.id)
      this.setState({ customer: response });
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined || response[key] === null ? "" : response[key]
      });
      const dist = await apiCall(`get-dist/${response.city_id}`, 'get', null);
      this.setState({ formData: updatedData, districts: dist, isLoad: false }, () => { });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  getCariTransactonsSummery = async () => {
    const id = this.props.match.params.id;
    try {
      if (id) {
        const response = await apiCall('business/receivable/cari/summery/' + id, 'get', null);
        this.setState({ summery: response }, () => { });
      }
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  getCities = async () => {
    const response = await apiCall('get-cities', 'get', null);
    this.setState({ cities: response });
  }
  handleCityChange = async (event) => {
    const city_id = event.target.value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        city_id: city_id,
        district_id: ""
      },
      districts: []
    }));

    if (city_id) {
      const response = await apiCall(`get-dist/${city_id}`, 'get', null);
      this.setState({ districts: response });
    }
  }
  handleChange = (e) => {
    const { id, type, checked, value } = e.target;

    let inputValue;
    if (type === 'checkbox') {
      inputValue = !!checked;
    } else {
      inputValue = value;
    }

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: inputValue
      }
    }));
  };
  handleFilterChange = (e) => {
    const { id, value } = e.target;

    this.setState(prevState => ({
      cariByCompanyFilter: {
        ...prevState.cariByCompanyFilter,
        [id]: value
      }
    }));
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const customerFormData = new FormData();
    Object.keys(formData).forEach(key => {
      customerFormData.append(key, formData[key]);
    });

    try {
      const response = await apiCall('business/customer/update/' + formData.id, 'post', customerFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message)
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  checkTaxPayer = async () => {
    try {
      Swal.fire({
        title: 'Sorgulama Yapılıyor...',
        text: 'Lütfen bekleyin, mükellef bilgileri sorgulanıyor...',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const tax_no = this.state.formData.tax_no;
      if (!tax_no || tax_no.length < 10) {
        Swal.close();
        Swal.fire({
          title: 'Uyarı!',
          text: 'Lütfen geçerli bir VKN/TCKN giriniz (en az 10 haneli).',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
        return;
      }

      const response = await apiCall('business/customer/check-taxpayer/' + tax_no, 'get', null);

      if (response.status === 'error') {
        Swal.close();
        Swal.fire({
          title: 'Bilgilendirme',
          html: response.message || 'Bu kişiye ait e-fatura kaydı bulunamadı.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
        return;
      }

      const { data } = response;

      if (!data) {
        Swal.close();
        Swal.fire({
          title: 'Bilgilendirme',
          html: 'Bu kişiye ait e-fatura kaydı bulunamadı.<br><small class="text-muted">Kişi e-arşiv fatura kullanıcısı olabilir.</small>',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
        return;
      }

      // Form alanlarını otomatik doldur
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          title: data.unvan || prevState.formData.title,
          urn: data.urn || '',
          invoice_type: data.invoice_type || 'EARSIV'
        }
      }));

      Swal.close();

      const messages = [];
      messages.push(`<strong>VKN/TCKN:</strong> ${data.vkn_tckn || 'Yok'}`);
      messages.push(`<strong>Ünvan:</strong> ${data.unvan || 'Yok'}`);
      messages.push(`<strong>URN (Etiket):</strong> ${data.urn || 'Yok'}`);
      messages.push(`<strong>Fatura Tipi:</strong> <span style="color: ${data.invoice_type === 'EFATURA' ? '#28a745' : '#ff9800'}; font-weight: bold;">${data.invoice_type || 'EARSIV'}</span>`);
      if (data.tip) messages.push(`<strong>Tip:</strong> ${data.tip}`);

      Swal.fire({
        title: 'İşlem tamamlandı!',
        html: messages.join('<br>'),
        icon: 'success',
        confirmButtonText: 'Tamam'
      });

    } catch (error) {
      console.error('checkTaxPayer error:', error);
      Swal.close();
      Swal.fire({
        title: 'Hata!',
        text: error?.response?.data?.message || error.message || 'Mükellef sorgulanırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }
  }
  allReceivablesWithCollections = async () => {
    try {
      Swal.fire({
        title: 'Sorgulama Yapılıyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await apiCall('business/receivable/by-company/' + this.state.formData.id, 'get', null);
      if (response.length === 0) {
        Swal.fire({
          title: 'Uyarı!',
          text: 'Müşteri/Tedarikçi ye ait veri bulunamadı.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
      }
      this.setState({ cariByCompany: response });
      Swal.close();
    } catch (error) {
      Swal.fire({
        title: 'Hata!',
        text: 'Veriler alınırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }
  }
  handleFilterSubmit = async (e) => {
    e.preventDefault();
    if (this.state.cariByCompanyFilter.time && (this.state.cariByCompanyFilter.start_time || this.state.cariByCompanyFilter.end_time)) {
      Swal.fire({
        title: 'Uyarı',
        text: 'Periyod seçili iken tarih seçilmemelidir!',
        icon: 'warning',
        confirmButtonText: 'Tamam'
      });
      return;
    }
    this.setState({ filterLoading: true });
    const { cariByCompanyFilter } = this.state;
    const filterFormData = {
      time: cariByCompanyFilter.time,
      end_time: cariByCompanyFilter.end_time,
      start_time: cariByCompanyFilter.start_time
    };

    try {
      const response = await apiCall('business/receivable/by-company-filter/' + this.state.formData.id, 'post', filterFormData);

      this.setState({
        cariByCompany: response.data,
        calculates: response.calcs,
        filterLoading: false
      });
    } catch (e) {
      console.error(e)
      this.setState({ filterLoading: false });
    }
  }
  exportToExcel = (cariByCompany, totals) => {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Cari Hareketler');

    const addReceivableHeaders = (worksheet) => {
      const headerRow = worksheet.addRow(["ID", "Servis No", "Tip", "Son Ödeme Tarihi", "Tutar", "Kalan Tutar", "Durum"]);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF0070C0' }
        };
        cell.font = { color: { argb: 'FFFFFFFF' } };
      });
    };

    cariByCompany.forEach((receivable) => {
      addReceivableHeaders(worksheet);

      worksheet.addRow([
        receivable.id,
        receivable.operation?.id || receivable.operation_id || "Bağımsız cari",
        receivable.b_a === "alacak" ? "Alacak" : "Borç",
        MainHelper.dateFormat(receivable.due_date).split(' 0')[0],
        receivable.amount,
        receivable.remaining_amount === null || receivable.remaining_amount === undefined
            ? receivable.amount
            : receivable.remaining_amount,
        receivable.status
      ]);

      if (receivable.collections.length > 0) {
        const collectionHeaderRow = worksheet.addRow(["", "Ödenen Tutar", "Kalan Tutar", "Tahsilat/Ödeme Tarihi", "Ödeme Tipi", "Banka", "Açıklama"]);

        collectionHeaderRow.eachCell((cell) => {
          cell.font = { bold: true };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFA500' }
          };
          cell.font = { color: { argb: 'FFFFFFFF' } };
        });

        receivable.collections.forEach((collection) => {
          worksheet.addRow([
            "", // ID boş
            collection.amount,
            collection.remaining_amount,
            MainHelper.dateFormat(collection.collection_date).split(' 0')[0],
            collection.payment_type,
            collection.bank?.name,
            collection.description
          ]);
        });
      }
    });

    worksheet.addRow([]);

    worksheet.addRow(["", "Özet Bilgiler"]);
    worksheet.addRow(["", "Toplam Ödenen", totals.totalPaid]);
    worksheet.addRow(["", "Toplam Tahsilat", totals.totalReceived]);
    worksheet.addRow(["", "Kalan Borç", totals.totalDebt]);
    worksheet.addRow(["", "Kalan Alacak", totals.totalCredit]);
    worksheet.addRow(["", "Bakiye", totals.balance]);

    const summaryRowStart = worksheet.lastRow.number - 5;
    for (let i = summaryRowStart; i <= worksheet.lastRow.number; i++) {
      const row = worksheet.getRow(i);
      row.eachCell((cell) => {
        cell.font = { bold: true };
      });
    }

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = this.state.formData.name + '.xlsx' || this.state.formData.title + '.xlsx';
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };
  render() {
    const { formData, loading, districts, cities, summery, cariByCompany, filterLoading } = this.state;
    const { userPermissions, subscriptionCode } = this.props;
    const userHasUpdateCustomerPermission = userPermissions.includes('update customer');
    const code = subscriptionCode !== "none" && subscriptionCode !== "t22Vh3S";
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText={this.state.formData.is_supplier === 0 ? "Müşteri Detayları" : "Tedarikçi Detayları"}
              Breadcrumb={[
                {
                  name: `${this.state.formData.is_supplier === 0 ? "Müşteriler" : "Tedarikçiler"}`,
                  navigate: Number(this.state.formData.is_supplier) === 0 ? "customers-all" : "suppliers"
                },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    {/* Temel Bilgiler Card - Sol */}
                    <div className="col-lg-6 col-md-12">
                      <div className="card mb-3" style={{ border: '1px solid #e5e7eb', borderRadius: '0.75rem', height: '100%' }}>
                        <div className="card-body">
                          <h6 style={{
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: '#1f2937',
                            marginBottom: '1rem',
                            paddingBottom: '0.5rem',
                            borderBottom: '2px solid #e5e7eb'
                          }}>
                            <i className="fa fa-user mr-2" style={{ color: '#667eea' }}></i>
                            Temel Bilgiler
                          </h6>
                          <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                              <div className="form-group">
                                <label htmlFor="is_supplier" className="font-weight-bold text-cyan">
                                  Müşteri Tipi
                                </label>
                                <select
                                  className="form-control"
                                  id="is_supplier"
                                  value={this.state.formData.is_supplier}
                                  onChange={this.handleChange}>
                                  <option value="">Tip Seçiniz</option>
                                  <option value="0">👤 Müşteri</option>
                                  <option value="1">🏭 Tedarikçi</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="row clearfix">
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="name" className="font-weight-bold text-cyan">
                                  Adı *
                                </label>
                                <input
                                  id="name"
                                  className="form-control"
                                  placeholder="Ad giriniz"
                                  type="text"
                                  value={formData.name}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="surname" className="font-weight-bold text-cyan">
                                  Soyadı *
                                </label>
                                <input
                                  id="surname"
                                  className="form-control"
                                  placeholder="Soyad giriniz"
                                  type="text"
                                  value={formData.surname}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row clearfix">
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="phone" className="font-weight-bold text-cyan">
                                  Telefon
                                </label>
                                <input
                                  id="phone"
                                  className="form-control"
                                  placeholder="05XX XXX XX XX"
                                  type="text"
                                  value={formData.phone}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="email" className="font-weight-bold text-cyan">
                                  E-posta
                                </label>
                                <input
                                  id="email"
                                  className="form-control"
                                  placeholder="ornek@email.com"
                                  type="email"
                                  value={formData.email}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row clearfix">
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="city_id" className="font-weight-bold text-cyan">
                                  İl
                                </label>
                                <select
                                  className="form-control"
                                  id="city_id"
                                  value={formData.city_id}
                                  onChange={this.handleCityChange}>
                                  <option value="">İl Seçiniz</option>
                                  {cities && (cities.map(city => (
                                    <option key={city.id}
                                      value={city.id}>{city.name}</option>
                                  )))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="district_id" className="font-weight-bold text-cyan">
                                  İlçe
                                </label>
                                <select
                                  className="form-control"
                                  id="district_id"
                                  value={formData.district_id}
                                  onChange={this.handleChange}>
                                  <option value="">İlçe Seçiniz</option>
                                  {districts && (districts.map(district => (
                                    <option key={district.id}
                                      value={district.id}>{district.name}</option>
                                  )))}
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                              <div className="form-group">
                                <label htmlFor="address" className="font-weight-bold text-cyan">
                                  Adres
                                </label>
                                <textarea
                                  id="address"
                                  className="form-control"
                                  placeholder="Açık adres giriniz..."
                                  value={formData.address}
                                  onChange={this.handleChange}
                                  rows={3}>
                                </textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Şirket & Fatura Bilgileri Card - Sağ */}
                    <div className="col-lg-6 col-md-12">
                      <div className="card mb-3" style={{ border: '1px solid #e5e7eb', borderRadius: '0.75rem', height: '100%' }}>
                        <div className="card-body">
                          <h6 style={{
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: '#1f2937',
                            marginBottom: '1rem',
                            paddingBottom: '0.5rem',
                            borderBottom: '2px solid #e5e7eb'
                          }}>
                            <i className="fa fa-file-text mr-2" style={{ color: '#667eea' }}></i>
                            Şirket & Fatura Bilgileri
                          </h6>

                          <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                              <div className="form-group">
                                <label htmlFor="title" className="font-weight-bold text-cyan">
                                  Ünvan
                                </label>
                                <input
                                  id="title"
                                  className="form-control"
                                  placeholder="Ünvan giriniz"
                                  value={formData.title}
                                  type="text"
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row clearfix">
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="tax_no" className="font-weight-bold text-cyan">
                                  Vergi / TC No
                                </label>
                                <input
                                  id="tax_no"
                                  className="form-control"
                                  placeholder="11 haneli numara"
                                  value={formData.tax_no}
                                  type="number"
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label htmlFor="tax_district" className="font-weight-bold text-cyan">
                                  Vergi Dairesi
                                </label>
                                <input
                                  id="tax_district"
                                  className="form-control"
                                  placeholder="Vergi dairesi adı"
                                  value={formData.tax_district}
                                  type="text"
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                              <div className="form-group">
                                <label htmlFor="urn" className="font-weight-bold text-cyan">
                                  E-Fatura Urn Adresi (Etiket)
                                </label>
                                <input
                                  id="urn"
                                  className="form-control"
                                  placeholder="urn:mail:example@domain.com"
                                  value={formData.urn ? formData.urn : ''}
                                  type="text"
                                  onChange={this.handleChange}
                                />
                                <small className="text-muted">
                                  * Mükellef doğrulama ile otomatik doldurulur veya manuel girebilirsiniz
                                </small>
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12">
                              <div className="form-group">
                                <label htmlFor="invoice_type" className="font-weight-bold text-cyan">
                                  Fatura Tipi
                                </label>
                                <select
                                  id="invoice_type"
                                  className="form-control"
                                  value={formData.invoice_type ? formData.invoice_type : 'EARSIV'}
                                  onChange={this.handleChange}>
                                  <option value="EARSIV">E-Arşiv</option>
                                  <option value="EFATURA">E-Fatura</option>
                                </select>
                                <small className="text-muted">
                                  * Mükellef doğrulama ile otomatik seçilir
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="row clearfix justify-content-center" style={{ marginTop: '1rem', marginBottom: '1.5rem' }}>
                    <div className="col-lg-8 col-md-12">
                      {loading ? (
                        <button
                          className="btn btn-outline-primary btn-lg btn-block"
                          disabled={true}
                          style={{
                            borderRadius: '0.5rem',
                            padding: '0.75rem',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderWidth: '2px'
                          }}>
                          <ReactLoading type="spin" width={'20px'} height={'20px'} color="#007bff" />
                          <span className="ml-2">İşlem Yapılıyor...</span>
                        </button>
                      ) : (
                        <button
                          disabled={!userHasUpdateCustomerPermission}
                          className="btn btn-outline-primary btn-lg btn-block"
                          type="submit"
                          style={{
                            borderRadius: '0.5rem',
                            padding: '0.75rem',
                            fontWeight: '500',
                            borderWidth: '2px',
                            transition: 'all 0.3s ease',
                            opacity: userHasUpdateCustomerPermission ? 1 : 0.5
                          }}>
                          <i className="fa fa-save mr-2"></i>
                          Güncelle
                        </button>
                      )}

                      {this.state.formData.tax_no && this.state.formData.tax_no.trim() !== "" && (
                        <button
                          onClick={this.checkTaxPayer}
                          className="btn btn-outline-info btn-lg btn-block mt-2"
                          type="button"
                          style={{
                            borderRadius: '0.5rem',
                            padding: '0.75rem',
                            fontWeight: '500',
                            borderWidth: '2px',
                            transition: 'all 0.3s ease'
                          }}>
                          <i className="fa fa-check-circle mr-2"></i>
                          Mükellef Doğrula
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>Cari Geçmişi</h2>
                  </div>
                  {code ? (
                    <>
                      <div className="mt-3">
                        <div className="col-lg-12">
                          {this.state.formData.id && (
                            <CariTransactionsTable></CariTransactionsTable>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 mb-3">
                        <div className="col-md-12 text-right">
                          <p className="m-b-0">
                            <b>Toplam Alacak:</b> {formattedPrice(summery.total_receivables)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Toplam Borç:</b> {formattedPrice(summery.total_debt)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Toplam Tahsil Edilen:</b> {formattedPrice(summery.total_collected_receivables)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Toplam Ödenen:</b> {formattedPrice(summery.total_paid_debt)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Toplam Kdv:</b> {formattedPrice(summery.total_vat)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Kalan Borç:</b> {formattedPrice(summery.total_remaining_debt)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Kalan Alacak:</b> {formattedPrice(summery.total_remaining_receivables)}
                          </p>
                          <p className="m-b-0 mt-2 ml-3">
                            <b>Bakiye:</b> {formattedPrice(summery.total_balance)} {summery.total_balance <= 0 ? "(Borç)" : "(Alacak)"}
                          </p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="body">
                      <div className="col-lg-12 justify-content-center d-flex">
                        <div className="col-md-6 text-center">
                          <div className="alert alert-danger"><i className="icon-ban"></i> Bu özelliği kullanmak için plan yükseltin! </div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>

            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>Dönem ve Tarihe göre Tahsilat Hareketleri (Excell)</h2>
                    <div className="text-right m-2">
                      {Object.keys(this.state.cariByCompany).length > 0 && code && (
                        <button onClick={() => this.exportToExcel(this.state.cariByCompany, {
                          totalPaid: this.state.calculates.total_paid_debt,
                          totalReceived: this.state.calculates.total_receivables,
                          totalDebt: this.state.calculates.total_remaining_debt,
                          totalCredit: this.state.calculates.total_remaining_receivables,
                          balance: this.state.calculates.total_balance
                        })} className="btn btn-outline-info">
                          <i className="fa fa-file-excel-o"></i> Dışarı Aktar
                        </button>
                      )}

                    </div>
                  </div>
                  {code ? (
                    <>
                      <div className="body">
                        <div className="row clearfix">
                          <div className="col-lg-3 col-md-12">
                            <label htmlFor="time">Periyod</label>
                            <div className="form-group">
                              <select id='time' className="form-control" onChange={this.handleFilterChange}>
                                <option value="">Seçiniz</option>
                                <option value="daily">Günlük</option>
                                <option value="weekly">Haftalık</option>
                                <option value="monthly">Aylık</option>
                                <option value="yearly">Yıllık</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-12">
                            <div className="form-group">
                              <label htmlFor="start_time">Başlangıç Tarihi</label>
                              <input
                                id='start_time'
                                type="date"
                                className="form-control"
                                onChange={this.handleFilterChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-12">
                            <div className="form-group">
                              <label htmlFor="end_time">Bitiş Tarihi</label>
                              <input
                                id='end_time'
                                type="date"
                                className="form-control"
                                onChange={this.handleFilterChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-12">
                            <div className="form-group">
                              <label htmlFor="">&nbsp;</label>
                              {filterLoading ? (
                                <button className="btn btn-outline-primary btn-block"
                                  disabled={true}
                                  style={{ textAlign: "-webkit-center" }}>
                                  Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                    height={'24px'}
                                    color="#268bd2"></ReactLoading>
                                </button>
                              ) :
                                <button onClick={this.handleFilterSubmit}
                                  className="btn btn-outline-primary btn-block"
                                  type="submit">
                                  Filtrele
                                </button>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <div className="col-lg-12">
                          {this.state.formData.id && (
                            <>
                              <div className="table-responsive mb-3">
                                <table className="table m-b-0 table-hover">
                                  <thead className="thead-light">

                                  </thead>
                                  <tbody>
                                    {cariByCompany && cariByCompany.map((receivable, index) => (
                                      <>
                                        <tr className="table-info">
                                          <th>ID</th>
                                          <th>Servis No</th>
                                          <th>Tip</th>
                                          <th>Son Ödeme Tarihi</th>
                                          <th>Tutar</th>
                                          <th>Kalan Tutar</th>
                                          <th>Durum</th>
                                          <th></th>
                                          <th></th>
                                        </tr>
                                        {/* Ana satır: Receivable verisi */}
                                        <tr key={`receivable-${index}`} className="table-success">
                                          <td>{receivable.id}</td>
                                          <td><ReceivableServiceCell row={receivable} canView={userPermissions.includes('view service')} /></td>
                                          <td>{receivable.b_a === "alacak" ? "Alacak" : "Borç"}</td>
                                          <td>{MainHelper.dateFormat(receivable.due_date).split(' 0')[0]}</td>
                                          <td>{formattedPrice(receivable.amount)}</td>
                                          <td>{formattedPrice(
                                              receivable.remaining_amount === null || receivable.remaining_amount === undefined
                                                  ? receivable.amount
                                                  : receivable.remaining_amount
                                          )}</td>
                                          <td>
                                            <span
                                              className={`badge badge-${receivable.status === "Ödendi" ? "success" : "danger"}`}>
                                              {receivable.status}
                                            </span>
                                          </td>
                                          <td><ReceivableServiceLink row={receivable} canView={userPermissions.includes('view service')} /></td>
                                          <td></td>
                                        </tr>

                                        {/* Alt başlık: Collection bilgileri */}
                                        {receivable.collections.length > 0 && (
                                          <tr className="thead-light">
                                            <th><i className="fa fa-level-down"
                                              style={{
                                                marginRight: '5px',
                                                transform: 'rotate(-90deg) scaleX(-1)',
                                                fontSize: "x-large"
                                              }}></i></th>
                                            <th colSpan="2" className="pl-4 table-secondary">
                                              Ödenen Tutar
                                            </th>
                                            <th>Kalan Tutar</th>
                                            <th>Tahsilat/Ödeme Tarihi</th>
                                            <th>Ödeme Tipi</th>
                                            <th>Banka</th>
                                            <th>Açıklama</th>
                                            <th></th>
                                          </tr>
                                        )}

                                        {/* Alt satırlar: Collection verileri */}
                                        {receivable.collections.map((collection, i) => (
                                          <tr key={`collection-${index}-${i}`}>
                                            <td></td>
                                            <td colSpan="2" className="pl-4">
                                              {formattedPrice(collection.amount)}
                                            </td>
                                            <td>{formattedPrice(collection.remaining_amount)}</td>
                                            <td>{MainHelper.dateFormat(collection.collection_date).split(' 0')[0]}</td>
                                            <td>{collection.payment_type}</td>
                                            <td>{collection.bank?.name || ''}</td>
                                            <td>{collection.description}</td>
                                            <td></td>
                                          </tr>
                                        ))}
                                      </>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              <div className="mt-3 mb-3">
                                <div className="col-md-12 text-right">
                                  <p className="m-b-0">
                                    <b>Toplam Ödenen:</b> <b
                                      className="text-danger">{formattedPrice(this.state.calculates.total_paid_debt)}</b>
                                  </p>
                                  <p className="m-b-0 mt-2 ml-3">
                                    <b>Toplam Tahsilat:</b> <b
                                      className="text-success">{formattedPrice(this.state.calculates.total_receivables)}</b>
                                  </p>
                                  <p className="m-b-0 mt-2 ml-3">
                                    <b>Kalan Borç:</b> <b
                                      className="text-danger">{formattedPrice(this.state.calculates.total_remaining_debt)}</b>
                                  </p>
                                  <p className="m-b-0 mt-2 ml-3">
                                    <b>Kalan Alacak:</b> <b
                                      className="text-success">{formattedPrice(this.state.calculates.total_remaining_receivables)}</b>
                                  </p>
                                  <p className="m-b-0 mt-2 ml-3">
                                    <b>Bakiye:</b>
                                    <b className={`${this.state.total_balance > 0 ? "text-success" : "text-danger"}`}>
                                      {formattedPrice(this.state.calculates.total_balance)} {this.state.calculates.total_balance > 0 ? "(Alacak)" : (this.state.calculates.total_balance < 0 ? "(Borç)" : "")}
                                    </b>
                                  </p>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="body">
                      <div className="col-lg-12 justify-content-center d-flex">
                        <div className="col-md-6 text-center">
                          <div className="alert alert-danger"><i className="icon-ban"></i> Bu özelliği kullanmak için plan yükseltin! </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
  customer_id: ioTReducer.customer_id
});

export default subscriptionPermissionsControl(withPermissions(withRouter(connect(mapStateToProps, { setCustomerID })(CustomerDetail))));
